export const GlobalVariable = Object.freeze({
  SESSION_ID: 'sessionid',
  USER_NAME: 'userName',
  RIGHTS: 'rights',
  LANGUAGE: 'language',
  AUDIO: 'audio'
});
